"use client";

import { FeedbackList } from "./feedback/FeedbackList";
import { FeedbackDetail } from "./feedback/FeedbackDetail";

export function FeedbackOutboxView({ canWrite }: { canWrite: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <FeedbackList mode="outbox" canWrite={canWrite} />
      <FeedbackDetail canWrite={canWrite} />
    </div>
  );
}
